import { findIndex, get } from 'lodash';
import { createSelector } from 'reselect';

// Collection
export const isCollectionsLoading = ( state ) => get( state, 'collections.isLoading', false );
const activeCollectionSelector = ( state, props ) => get( state, `collections.byId[${props.match.params.collectionId}]`, null );

// Canvases for Active Collection
const canvasesByIdSelector = state => get( state, 'canvases.byId', {} );
export const collectionTabItemsSelector = state => get( state, 'uiState.collectionTabItems', [] );
export const selectedCollectionTabIdSelector = ( state ) => get( state, 'uiState.selectedCollectionTabId', 0 );

/* Returns index of currently selected collection tab */
export const selectedCollectionTabIndexSelector = createSelector(
    collectionTabItemsSelector,
    selectedCollectionTabIdSelector,
    ( collectionTabs, selectedTabId ) => {
        if( collectionTabs.length === 0 ){
            return 0;
        }

        const index = findIndex( collectionTabs, ( tab ) => tab.id === selectedTabId );
        return index < 0 ? 0 : index;
    }
);

/* Returns all canvases for the currently selected collection */
export const selectedCollectionWithCanvasesSelector = createSelector(
    activeCollectionSelector,
    canvasesByIdSelector,
    ( collection, canvasesMap ) => {
        if( !collection ){
            return {};
        }

        return {
            ...collection,
            canvases: collection.canvases.map( ( canvasId ) => canvasesMap[canvasId] ),
            url: `/${collection.id}`,
        };
    }
);
